import { render, staticRenderFns } from "./TemplateMailListTable.vue?vue&type=template&id=4678cb60"
import script from "./TemplateMailListTable.vue?vue&type=script&lang=js"
export * from "./TemplateMailListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports